import React, { useState } from "react"
import "../css/main.css"
import Navbar from "./Navbar"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
const Layout = ({ children }) => {
  const [isOpened, setIsOpened] = useState(false)
  const toggleSideBar = () => {
    setIsOpened(!isOpened)
  }
  return (
    <>
      <Navbar toggleSideBar={toggleSideBar}/>
      <Sidebar toggleSideBar={toggleSideBar} isOpened={isOpened}/>
      {children}
      <Footer/>
    </>
  )
}

export default Layout
